import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiSearch, FiUser, FiShoppingCart } from "react-icons/fi";
import logo from "../../assets/image/logo.png";
import switchImg from "../../assets/image/switechs/01.webp";
import "./header.css";

const Header = () => {

  useEffect(() => {
    const openBtn = document.getElementById("openSearch");
    const closeBtn = document.getElementById("closeSearch");
    const overlay = document.getElementById("searchOverlay");

    if (!openBtn || !overlay) return;

    openBtn.onclick = (e) => {
      e.preventDefault();
      overlay.classList.add("active");
    };

    closeBtn.onclick = () => overlay.classList.remove("active");
  }, []);

  const hoverLikeOpen = (e) => {
    const li = e.currentTarget.parentElement;

    if (window.innerWidth <= 991) {
      if (!li.classList.contains("mobile-open")) {
        e.preventDefault();

        document
          .querySelectorAll(".nav-item.mobile-open")
          .forEach(item => item.classList.remove("mobile-open"));

        li.classList.add("mobile-open");
      }
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg nx-header">
        <div className="container">

          {/* LOGO */}
          <Link to="/" className="nx-logo">
            <img src={logo} alt="NXO" />
          </Link>

          {/* HAMBURGER */}
          <button
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#nxNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* MENU */}
          <div className="collapse navbar-collapse" id="nxNav">
            <ul className="navbar-nav ms-4 gap-3">

              <li className="nav-item position-static">
                <Link className="nav-link" to="/">Home</Link>
              </li>

              <li className="nav-item position-static">
                <a
                  href="/products"
                  className="nav-link"
                  onTouchStart={hoverLikeOpen}
                >
                  Our Products
                </a>

                <div className="mega-menu">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-3 mega-left p-0">
                        <div className="nav flex-column nav-pills">
                          <button className="nav-link active">Switches</button>
                          <button className="nav-link">Transceivers</button>
                          <button className="nav-link">Cables</button>
                        </div>
                      </div>

                      <div className="col-lg-9 p-4">
                        <div className="mega-box">
                          <img src={switchImg} alt="Enterprise Switches" />
                          <h6>Enterprise Switches</h6>
                          <ul className="switch-list">
                            <li>1/2.5G Enterprise Switches</li>
                            <li>10G Enterprise Switches</li>
                            <li>25G Enterprise Switches</li>
                            <li>40G Enterprise Switches</li>
                            <li>100G Enterprise Switches</li>
                            <li>Modular Enterprise Switches</li>
                            <li>Switch Accessories</li>
                          </ul>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </li>
    <li className="nav-item position-static">
                <a href="/contact" className="nav-link" onTouchStart={hoverLikeOpen}>
                  Support
                </a>

                <div className="mega-menu">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-3 mega-left p-0">
                        <div className="nav flex-column nav-pills">
                          <button className="nav-link active">Enterprise</button>
                          <button className="nav-link">Data Center</button>
                        </div>
                      </div>
                      <div className="col-lg-9 p-4">
                        <h6>Campus Networks</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* ABOUT */}
              <li className="nav-item position-static">
                <a href="/about" className="nav-link" onTouchStart={hoverLikeOpen}>
                  About Us
                </a>

                <div className="mega-menu">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-3 mega-left p-0">
                        <div className="nav flex-column nav-pills">
                          <button className="nav-link active">Support</button>
                          <button className="nav-link">Consulting</button>
                        </div>
                      </div>
                      <div className="col-lg-9 p-4">
                        <h6>24/7 Technical Support</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* ICONS */}
          <div className="nx-icons">
            <button id="openSearch" className="icon-btn">
              <FiSearch size={18} />
            </button>

            <Link to="/login" className="icon-btn">
              <FiUser size={18} />
            </Link>

            <Link to="/cart" className="icon-btn">
              <FiShoppingCart size={18} />
            </Link>
          </div>

        </div>
      </nav>

      {/* SEARCH */}
      <div id="searchOverlay" className="search-overlay">
        <div className="search-box">
          <button id="closeSearch" className="close-search">×</button>
          <input type="text" placeholder="Search products..." />
        </div>
      </div>
    </>
  );
};

export default Header;
